import { Button, Col, Form, Row } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { AdminUserRequest } from '../../../../request/AuthRequest';
import InputComponent from '../../../../component/InputComponent';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';

const ChangePassword = observer(() => {
	const [form] = Form.useForm();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState();
	const { ADMINUSER } = useStore();

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields()
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};

	const handleSubmit = (formData) => {
		setSaving(true);
		formData['NewPassword'] = formData.cn_password;
		delete formData.cn_password;
		delete formData.password;
		ADMINUSER.updateUser(formData)
			.then((data) => {
				if (data) {
					Notification.success({
						message: data,
					});
					form.resetFields();
				}
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	return (
		<Form
			layout="vertical"
			id={'changePassword'}
			form={form}
			onFinish={handleSubmit}
			autoComplete="off"
		>
			<Row gutter={24}>
				<Col span={24}>
					<InputComponent
						required
						type="password"
						name="oldPassword"
						label="Old Password"
						placeholder="xxxxxxx"
						onChange={handleChange}
						rules={AdminUserRequest.password}
					/>
				</Col>
				<Col span={24}>
					<InputComponent
						required
						type="password"
						name="password"
						label="New Password"
						placeholder="xxxxxxx"
						onChange={handleChange}
						rules={AdminUserRequest.password}
					/>
				</Col>
				<Col span={24}>
					<InputComponent
						required
						type="password"
						name="cn_password"
						label="Confirm New Password"
						placeholder="xxxxxxx"
						onChange={handleChange}
						rules={AdminUserRequest.cn_password}
					/>
				</Col>
			</Row>
			<Button
				type="primary"
				key={1}
				disabled={disabled}
				htmlType="submit"
				loading={saving}
				form="changePassword"
			>
				Change Password
			</Button>
		</Form>
	);
});

export default ChangePassword;
